import type { DataPoint } from '@shopify/polaris-viz';

import { PLACEHOLDER_VALUE } from '~/modules/page-analytic';

export const formatPercent = (currentData: DataPoint) => {
  const value = currentData.trend?.value;
  if (!value) return PLACEHOLDER_VALUE;

  const valueNumber = Number(value.replace(/[%~]/g, ''));

  if (currentData.trend?.trend === 'negative') {
    return valueNumber * -1;
  }

  return valueNumber;
};
